import Model from './model.js';
import FileInfo from './fileInfo.js';

export default class RationCard extends Model
{
    constructor(id, personId, cardNumber, file = null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.cardNumber         = cardNumber;
        this.file               = file ?? new FileInfo();

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }

    setBinaryFile(binaryFile){
        if (!this.file || typeof this.file !== 'object') this.file = new FileInfo();
        this.file.binaryFile = binaryFile ?? null;
    }

    mapToUpdate(){
        let formData = new FormData();
        formData.append('cardNumber', this.cardNumber ?? "")

        if (this.file?.binaryFile) formData.append('file', this.file?.binaryFile)

        return formData;
    }

    mapToCreate(){
        let formData = this.mapToUpdate();
        formData.append('personId', this.personId ?? null)
        
        return formData;
    }
}
